import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon5 } from "../../assets/icons/Fork5.svg";

const DrivingGrowth = () => {
  const items = [
    {
      title: "No Clue Which Links Drive Installs?",
      description:
        "Track installs, re-installs, re-engagements, time spent, and more—down to the link level.",
    },

    {
      title: "Can’t Compare Campaigns?",
      description:
        "Compare any campaign across platforms, time ranges, or audiences to know what performs best.",
    },

    {
      title: "Missing User-Level Insights?",
      description:
        "See who opened which links, referred new users, how many they brought in, and when they were last active.",
    },

    {
      title: "Lack of Referral Clarity?",
      description:
        "Track referral chains and view metrics for each user’s links: installs, opens, views, and re-installs.",
    },
    {
      title: "Fragmented Metrics?",
      description:
        "Get all your performance data in one place—clean, consistent, and ready to act on",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"drivingGrowth"}>
        <Content>
          <TextWrapper>
            <Title>Tired of Not Knowing What’s Driving Growth?</Title>
            <Subtitle>
              Campaign performance shouldn’t be a mystery. Without clear
              insights, it’s impossible to tell what’s working and what’s not.
              With Grovs Analyse, you get a detailed view into every campaign,
              link, and user—so you can stop guessing and start optimizing.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon5 color="rgba(39, 16, 60, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {items.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default DrivingGrowth;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    text-align: center;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
